import { createAsyncThunk } from '@reduxjs/toolkit';
import { AuthApi, HStreamCallbackData } from 'api/AuthApi';

import { ErrorResponse } from './ErrorResponse';

export const createHStreamCallbackThunk = (api: AuthApi) =>
  createAsyncThunk('auth/hstreamCallback', async (data: HStreamCallbackData, thunkApi) => {
    try {
      return await api.hstreamCallback(data);
    } catch (error: unknown) {
      thunkApi.rejectWithValue((error as ErrorResponse).response?.data);
      throw error;
    }
  });
